// 本地化
function localization(item) {
  if (parseInt(item) === 1) {
    return '一居室'
  }

  if (parseInt(item) === 2) {
    return '两居室'
  }
  if (parseInt(item) === 3) {
    return '三居室'
  }
  if (parseInt(item) === 4) {
    return '四居室'
  }
  if (parseInt(item) === 5) {
    return '五居室'
  }
  if (parseInt(item) === 6) {
    return '六居室'
  }
  if (parseInt(item) === 7) {
    return '七居室'
  }
  if (parseInt(item) === 8) {
    return '八居室'
  }
  if (parseInt(item) === 9) {
    return '九居室'
  }

  return '未知'
}

// 格式化
function dataFormat(data, _this) {
  let bjModel = data.bj_bedroom
  let model = data.bedroom
  var option = null
  if (_this.$route.params.type === 0) {
    let keys = []
    let bjModels = []
    let models = []
    for (var i = 0; i < bjModel.length; i++) {
      keys.push(localization(bjModel[i].bedroom))
      bjModels.push({
        value: bjModel[i].count,
        name: localization(bjModel[i].bedroom)
      })
    }

    if (model.length !== 0) { // 有数据
      for (var j = 0; j < model.length; j++) {
        models.push({
          value: model[j].count,
          name: localization(model[j].bedroom)
        })
      }
    } else { // 没有数据
      for (var n = 0; n < bjModels.length; n++) {
        models.push({
          value: 0,
          name: bjModels[n].name
        })
      }
    }

    option = {
      legend_data: keys,
      title: [{
        text: '北京',
        textAlign: 'center',
        left: '49%',
        y: '32%'
      }, {
        text: _this.$route.params.name,
        textAlign: 'center',
        left: '49%',
        y: '74%'
      }],
      series: [{
        name: '北京',
        type: 'pie',
        radius: ['28%', '50%'],
        center: ['50%', '35%'],
        selectedMode: 'single',
        legend: {
          orient: 'vertical',
          left: 'right',
          top: 'center',
          data: keys
        },
        label: {
          normal: {
            show: false
          },
          emphasis: {
            show: true,
            textStyle: {
              fontSize: '30',
              fontWeight: 'bold'
            }
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        data: bjModels
      }, {
        name: _this.$route.params.name,
        type: 'pie',
        radius: ['28%', '50%'],
        center: ['50%', '76%'],
        selectedMode: 'single',
        label: {
          normal: {
            show: false
          },
          emphasis: {
            show: true,
            textStyle: {
              fontSize: '30',
              fontWeight: 'bold'
            }
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        data: models
      }]
    }
  } else {
    let keys = []
    let models = []
    for (var k = 0; k < model.length; k++) {
      keys.push(localization(model[k].bedroom))
      models.push({
        value: model[k].count,
        name: localization(model[k].bedroom)
      })
    }
    option = {
      legend_data: keys,
      title: [{
        text: '北京',
        textAlign: 'center',
        left: '49%',
        y: '43%'
      }],
      series: [{
        name: '北京',
        type: 'pie',
        radius: ['28%', '50%'],
        center: ['50%', '45%'],
        selectedMode: 'single',
        legend: {
          orient: 'vertical',
          left: 'right',
          top: 'center',
          data: keys
        },
        label: {
          normal: {
            show: false
          },
          emphasis: {
            show: true,
            textStyle: {
              fontSize: '30',
              fontWeight: 'bold'
            }
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        data: models
      }]
    }
  }
  return option
}

// 导出 option
export function creatOption(data, _this) {
  let params = dataFormat(data, _this)
  let option = {
    title: params.title,
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'horizontal',
      left: '3%',
      data: params.legend_data
    },
    series: params.series
  }
  return option
}



// WEBPACK FOOTER //
// ./src/components/chartjs/ModelChart.js